import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Search16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M4.51839 1.46036C3.10791 2.0598 1.99332 3.195 1.41983 4.61623C0.846337 6.03746 0.860915 7.62829 1.46036 9.03878C2.0598 10.4493 3.195 11.5638 4.61623 12.1373C6.03746 12.7108 7.62829 12.6963 9.03878 12.0968C9.50254 11.8997 9.93431 11.6447 10.3254 11.3406L13.7739 14.7897C14.0543 15.0701 14.5088 15.0701 14.7892 14.7898C15.0696 14.5094 15.0696 14.0548 14.7893 13.7745L11.3407 10.3253C11.6662 9.90664 11.9353 9.44153 12.1373 8.94094C12.7108 7.51971 12.6963 5.92887 12.0968 4.51839C11.4974 3.10791 10.3622 1.99332 8.94094 1.41983C7.51971 0.846337 5.92887 0.860915 4.51839 1.46036ZM9.86677 9.83184C10.2675 9.42654 10.5884 8.94244 10.8058 8.40364C11.2368 7.33556 11.2258 6.14001 10.7753 5.08C10.3249 4.01999 9.47173 3.18236 8.40364 2.75136C7.33556 2.32037 6.14001 2.33133 5.08 2.78182C4.01999 3.23231 3.18235 4.08544 2.75136 5.15352C2.32037 6.22161 2.33133 7.41716 2.78182 8.47717C3.23231 9.53718 4.08544 10.3748 5.15352 10.8058C6.22161 11.2368 7.41716 11.2258 8.47717 10.7753C8.98704 10.5587 9.44546 10.2488 9.83192 9.8667C9.83753 9.8607 9.84325 9.85478 9.8491 9.84893C9.85492 9.84311 9.86081 9.83742 9.86677 9.83184Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
